import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';
import { construireDonneesCommunes } from '../construireDonneesCommunes.js';

const CHEMIN_TEMPLATE = '/templates/CdC.docx';


function construireDonneesTemplate(formData, numDoc) {
  const { i2c } = formData.commun;
  const { contraintes, exigences } = formData.documents.conventionEtude;

  const donneesCommunes = construireDonneesCommunes(formData, 'CdC', numDoc);

  // Auteur principal
  const auteurPrincipal = i2c.contacts.find((c) => c.auteur) || {
    nom: '',
    prenom: '',
    mail: '',
  };

  // Présidence
  let libellePresidence;
  let mailsPresidence;

  if (donneesCommunes.estCopresidents) {
    libellePresidence = 'Coordonnées des Co-Présidents de la Junior';
    mailsPresidence =
      `${i2c.infoPresident1.mail} et ${i2c.infoPresident2.mail}`;
  } else {
    libellePresidence = 'Coordonnées du Président';
    mailsPresidence = i2c.infoPresident1.mail;
  }


  const contraintesTemplate = contraintes.map((c, index) => ({
    nomContrainte: `C_${index + 1} - ${c.nom}`,
    sousPoints: c.description
      .split('\n')
      .map((ligne) => ligne.trim())
      .filter(Boolean)
      .map((texte) => ({
        textePoint: texte,
      })),
  }));


  const exigencesTemplate = exigences.map((e, index) => ({
    nomExigence: `EF_${index + 1} - ${e.nom}`,
    sousPoints: e.description
      .split('\n')
      .map((ligne) => ligne.trim())
      .filter(Boolean)
      .map((texte) => ({
        textePoint: texte,
      })),
  }));


  return {
    ...donneesCommunes,

    nomAuteur: auteurPrincipal.nom,
    prenomAuteur: auteurPrincipal.prenom,
    mailAuteur: auteurPrincipal.mail,

    contraintes: contraintesTemplate,
    exigencesFonctionnelles: exigencesTemplate,

    libellePresidence,
    mailsPresidence,
  };
}


async function genererCahierDesCharges(formData, numDoc) {
  const reponse = await fetch(CHEMIN_TEMPLATE);

  if (!reponse.ok) {
    throw new Error(
      `Impossible de charger le template (${reponse.status})`
    );
  }

  const zip = new PizZip(await reponse.arrayBuffer());

  const doc = new Docxtemplater(zip, {
    paragraphLoop: true,
    linebreaks: true,
  });


  const donnees = construireDonneesTemplate(formData, numDoc);


  try {
    doc.render(donnees);
  } catch (error) {
    console.error('Erreur génération CdC :', error);

    if (error.properties?.errors) {
      console.error(
        JSON.stringify(error.properties.errors, null, 2)
      );
    }

    throw error;
  }


  const blob = doc.getZip().generate({
    type: 'blob',
    mimeType:
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  });


  saveAs(blob, `${donnees.refDocument}.docx`);
}


export default genererCahierDesCharges;